<div tid="contact_header" class="contact-header-container">
    <div class="item-profile">
        <img tid="contact_image" src="./assets/images/noportrait.png" class="img-circle" alt="profile">
    </div>
    <div tid="contact-info" class="item-contact-info h1-light">
        <div class="item-contact-info-elements">
            <div tid="contact_name" *ngIf="config.contact" class="item-name-value-embedded">
                {{config.contact.name}}
            </div>
            <div tid="edit_contact" #tooltip class="edit-icon" *ngIf="canEdit()" kendoTooltip position="bottom"
                tooltipClass="tooltip-adjust-right">
                <smart-icon name="pencil" (click)="editContact()" class="light" title="Edit"></smart-icon>
            </div>
            <div tid="link_To_Detail" #tooltip class="link-contact-detail" *ngIf="config.contact"
                (click)="goToContactDetail()" kendoTooltip position="bottom">
                <a class="link" (click)="diableLink($event)" [href]="'/tamaleweb/contact/'+config.contact.id">
                    <smart-icon name="sign-out" class="light" title="Go to detail page"></smart-icon>
                </a>
            </div>
        </div>
        <div *ngIf="false" tid="contact_position" class="caption-1 item-job">
            {{jobTitlesName}}
        </div>
    </div>
</div>